import React from "react"
import PropTypes from "prop-types"
import DatePicker from "react-datepicker"
import moment from "moment"
import { Field } from "redux-form"
import DateButton from "../../components/date-button"

const DatePickerWrapper = ({input, defaultDate}) => {
  const date = moment(input.value)
  return (
    <DatePicker
      customInput={<DateButton />}
      selected={date}
      minDate={defaultDate && moment(defaultDate)}
      onChange={input.onChange}
    />
  )
}

DatePickerWrapper.propTypes = {
  input: PropTypes.object,
}

const DateField = ({name, label, defaultDate}) => {
  return (
    <div className="edit-recurrings__date-field">
      {label && <label>{label}</label>}
      <Field name={name} props={{defaultDate: defaultDate}} component={DatePickerWrapper} />
    </div>
  )
}

DateField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string
}

export default DateField
